import React, { useEffect, useState } from "react"
import { useLocation } from "react-router-dom"
import { Loading } from "../../views/Loading"
import { adminCarrotClient } from "../../../utils/CarrotClient"
import { Error } from "../../views/Error"
import { SupportCenterUrlResponse } from "../../../types/supportCenterTypes"
import { reportError } from "../../../utils/ErrorReporting"

const RETURN_TO = "return_to"
const ZENDESK_LOCALE = "zendesk_locale"

const ServicesLoginContainer = (): JSX.Element => {
  const urlSearchParams = new URLSearchParams(useLocation().search)
  const returnToUrlString = urlSearchParams.get(RETURN_TO)
  const returnToUrlStringWithoutLocale = new URL("../hc", returnToUrlString).toString()
  const [error, setError] = useState(false)

  useEffect(() => {
    adminCarrotClient
      .getSupportCenterUrl()
      .then((response: SupportCenterUrlResponse) => {
        const supportCenterUrl = new URL(response.supportCenterUrl)
        // Zendesk Help Center link locale is case sensitive
        const zendeskLocale = supportCenterUrl.searchParams.get(ZENDESK_LOCALE).toLowerCase()

        supportCenterUrl.searchParams.set(RETURN_TO, `${returnToUrlStringWithoutLocale}/${zendeskLocale}`)

        window.location.href = supportCenterUrl.toString()
      })
      // @ts-expect-error TS7006
      .catch((error) => {
        reportError(error)
        setError(true)
      })
  }, [returnToUrlStringWithoutLocale])

  return error ? <Error /> : <Loading />
}

export { ServicesLoginContainer }
